var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPartsSelected = function SvgPartsSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m16.84 8.139 3.83-2.18a2.4 2.4 0 0 0-.56-.398l-7.193-4.095c-.621-.356-1.243-.55-1.844-.55-.61 0-1.232.194-1.854.55L7.151 2.638zm-5.767 3.27 5.766-3.27-9.688-5.501L2.038 5.56a2.7 2.7 0 0 0-.57.398zm.693 11.674a1 1 0 0 0 .204-.092l7.976-4.543c.947-.54 1.457-1.09 1.457-2.567V7.945c0-.306-.02-.55-.082-.774l-9.555 5.46zm-1.396 0V12.63L.815 7.17a3 3 0 0 0-.081.774v7.936c0 1.477.52 2.027 1.456 2.567l7.987 4.543c.061.04.122.071.193.092"
  })));
};
export default SvgPartsSelected;